// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__52KBK","overlay":"styles_overlay__uNQ9N"};